import React from 'react';
import { Target, Users, Award, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const AboutSection = () => {
  const values = [
    {
      icon: Target,
      title: 'Precision',
      description: 'Meticulous attention to every detail of your trademark application',
      stat: '100%',
      statLabel: 'Accuracy Rate'
    },
    {
      icon: Users,
      title: 'Expertise',
      description: '15+ years of specialized trademark registration experience',
      stat: '15+',
      statLabel: 'Years Experience'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: '95% success rate with USPTO trademark registrations',
      stat: '95%',
      statLabel: 'Success Rate'
    },
    {
      icon: TrendingUp,
      title: 'Results',
      description: 'Over 1000 trademarks successfully registered and protected',
      stat: '1000+',
      statLabel: 'Trademarks Filed'
    }
  ];

  return (
    <section id="about" className="py-20 bg-[#EFEBE9]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-6">
              Your Trusted Partner in Trademark Registration
            </h2>
            <div className="space-y-4 text-[#8D6E63] leading-relaxed text-lg">
              <p>
                At TradeMark Registry, we specialize exclusively in trademark registration services, providing businesses and entrepreneurs with the legal protection they need to safeguard their brand identity. Since 2008, we've been helping companies of all sizes—from startups to established enterprises—secure federal trademark protection and build lasting brand equity.
              </p>
              <p>
                With over 15 years of focused experience navigating the complexities of the United States Patent and Trademark Office (USPTO), our team of trademark professionals has successfully filed and registered over 1,000 trademarks across virtually every industry sector. Our deep understanding of USPTO examination procedures, office action responses, and trademark law ensures your application receives expert handling from start to finish.
              </p>
              <p>
                We understand that your brand is your most valuable asset—it represents years of hard work, customer relationships, and business reputation. That's why we treat every trademark application with the same level of care and attention we would give our own brand. Our comprehensive approach combines thorough trademark searches, strategic application preparation, proactive office action responses, and ongoing monitoring to deliver the strongest possible protection for your intellectual property.
              </p>
              <p>
                What sets us apart is our unwavering commitment to client success and transparent communication. We don't just file paperwork—we become your strategic partner in brand protection. From your initial consultation through final registration and beyond, we provide personalized guidance, regular updates, and expert advice to help you make informed decisions about your trademark portfolio.
              </p>
              <p className="font-semibold text-[#3E2723]">
                Our mission is simple: to make trademark registration accessible, affordable, and stress-free for businesses of all sizes, while delivering the highest quality legal services and achieving outstanding results that protect your brand for generations to come.
              </p>
            </div>
          </div>
          
          <div className="space-y-6">
            {/* Stats Cards */}
            <div className="grid grid-cols-2 gap-4">
              {values.map((value, index) => {
                const Icon = value.icon;
                return (
                  <Card
                    key={index}
                    className="border-2 border-[#D7CCC8] hover:border-[#8D6E63] transition-all duration-300 hover:shadow-lg bg-white"
                  >
                    <CardContent className="p-6">
                      <div className="w-12 h-12 bg-[#3E2723] rounded-lg flex items-center justify-center mb-4">
                        <Icon className="w-6 h-6 text-white" />
                      </div>
                      <h3 className="text-xl font-bold text-[#3E2723] mb-2">
                        {value.title}
                      </h3>
                      <p className="text-[#8D6E63] text-sm leading-relaxed mb-4">
                        {value.description}
                      </p>
                      <div className="pt-4 border-t border-[#D7CCC8]">
                        <div className="text-2xl font-bold text-[#3E2723]">{value.stat}</div>
                        <div className="text-xs text-[#8D6E63]">{value.statLabel}</div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
            
            {/* Additional Info Card */}
            <Card className="border-2 border-[#3E2723] bg-[#3E2723] text-white">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-3">Why Brand Protection Matters</h3>
                <p className="text-white/90 text-sm leading-relaxed mb-4">
                  In today's digital marketplace, your brand is your most valuable asset. Federal trademark registration provides the legal foundation to protect your business identity, prevent customer confusion, and build lasting brand equity.
                </p>
                <div className="grid grid-cols-3 gap-4 pt-4 border-t border-white/20">
                  <div>
                    <div className="text-2xl font-bold text-[#D7CCC8]">$1M+</div>
                    <div className="text-xs text-white/80">Avg Brand Value</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-[#D7CCC8]">50+</div>
                    <div className="text-xs text-white/80">States Protected</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-[#D7CCC8]">24/7</div>
                    <div className="text-xs text-white/80">Legal Protection</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
